import React, { useEffect, useMemo, useState } from "react";
import { useGetAllProviderQuery } from "../../services/chatService";
import { ReactSelectField } from "../reactHookFormFields/selectField";
import { useGroupChatContext } from "../../context/groupchatContext";
import { useWatch } from "react-hook-form";
import { CheckBox } from "../reactHookFormFields/checkbox";
import { PatientSearchField } from "../reactHookFormFields/patientSearchField";
import { 
    useGetGroupsQuery, 
    // useTasksMetaQuery 
} from "../../services/triageServices";
import { MdGroups } from "react-icons/md";
import ManageGroups from "../AddTask/ManageGroups";
import LoadingBanner from "../loader/LoadingBanner";

const TaskForm = React.memo(({ formHandler }) => {
  const groupChatContext = useGroupChatContext();
  const { selectedChatTab, selectedChat } = useMemo(() => ({
    selectedChatTab: groupChatContext.selectedChatTab,
    selectedChat: groupChatContext.selectedChat,
  }));

  const [assignedToData, setAssignedToData] = useState([]);
  const [openManageGroupsDialog, setOpenManageGroupsDialog] = useState(false);

  const { data: allProviders, isLoading: isLoadingProviders, isError: isAllProvidersError } = useGetAllProviderQuery();
  const { data: taskGroupsData, isLoading: isLoadingTaskGroups, isError: isTaskGroupsError } = useGetGroupsQuery();
//   const { data: taskMeta, isLoading: isTaskMetaLoading, isError: isTaskMetaError } = useTasksMetaQuery();

  useEffect(() => {
    if (!isLoadingProviders && !isLoadingTaskGroups) {
      const providerOptions = allProviders?.map((provider) => ({
        value: provider.User.id,
        label: provider.User.name,
      }));

      const taskGroupOptions = (taskGroupsData || [])?.map((group) => ({
        value: group?.id,
        label: `(${group?.user_array?.length || 0}) ${group?.title}`,
        type: "task_group",
        group_id: group?.id,
        user_ids: group?.user_array?.map((user) => user.id),
      }));

      setAssignedToData([...taskGroupOptions, ...providerOptions]);
    }
  }, [taskGroupsData, allProviders]);

  const assigneeProviderVal = useWatch({ control: formHandler.control, name: "assignee_provider" });

  useEffect(() => {
    if (assigneeProviderVal?.length < 2) {
      formHandler.setValue("auto_complete_all", false);
    }
  }, [assigneeProviderVal]);

  return (
    <form className="relative">
      <LoadingBanner
        loadingArrays={[
          { loading: isLoadingProviders || false, message: "Loading Providers..." },
          { loading: isLoadingTaskGroups || false, message: "Loading Task Groups..." },
        //   { loading: isTaskMetaLoading || false, message: "Loading Task Meta..." },
        ]}
      />
      {openManageGroupsDialog ? (
        <ManageGroups
          isOpen={openManageGroupsDialog}
          setIsOpen={setOpenManageGroupsDialog}
          taskGroupsData={taskGroupsData}
          allProviders={allProviders?.map((provider) => ({
            value: provider.User.id,
            label: provider.User.name,
          }))}
        />
      ) : null}
      <div className="items-center">
        <div className="flex flex-wrap gap-2 items-center">
          <div className="w-[70%] flex items-center gap-2">
            <ReactSelectField
              title="Assigned To"
              name="assignee_provider"
              isMulti={true}
              control={formHandler.control}
              optionData={assignedToData}
              menuPlacement={"bottom"}
              rules={{
                required: {
                  value: true,
                },
              }}
              errors={formHandler.errors}
              isLoading={isLoadingProviders || isLoadingTaskGroups}
            />
            <button
              className="bg-bgGreen text-white px-4 py-2 rounded-md hover:bg-bgGreen/90 flex items-center gap-2"
              type="button"
              onClick={() => setOpenManageGroupsDialog(true)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  setOpenManageGroupsDialog(true);
                }
              }}
              aria-label="Manage Groups"
              title="Manage Groups"
              disabled={isLoadingTaskGroups}
            >
              <MdGroups size={16} />
              <p className="text-sm whitespace-nowrap">Manage Groups</p>
            </button>
          </div>
          {selectedChatTab == "location_chats" ? (
            <div className="w-[49%]">
              <PatientSearchField
                title="Patient Search"
                name="patient"
                control={formHandler.control}
                location={selectedChat?.location?.id}
                rules={{
                  required: {
                    value: true,
                  },
                }}
                errors={formHandler.errors}
              />
            </div>
          ) : null}
          {assigneeProviderVal?.length > 1 ? (
            <div>
              <CheckBox
                title="Auto Complete for everyone when one assignee completes"
                name="auto_complete_all"
                control={formHandler.control}
                disabled={!assigneeProviderVal?.length}
              />
            </div>
          ) : null}
        </div>
      </div>
    </form>
  );
});

export default TaskForm;
